<div class="game-info-sub-section">{{ gameStatusLabel }}</div>

<div class="game-info-sub-section" *ngIf="shouldShowBiddingSection">
  <div>
    <div class="game-info-label">{{ userUsername }}:</div>
    <div class="game-info-value">
      {{ userBidLabel }}
    </div>
  </div>

  <div>
    <div class="game-info-label">{{ rightOpponentUsername }}:</div>
    <div class="game-info-value">
      {{ rightOpponentBidLabel }}
    </div>
  </div>

  <div>
    <div class="game-info-label">{{ leftOpponentUsername }}:</div>
    <div class="game-info-value">
      {{ leftOpponentBidLabel }}
    </div>
  </div>
</div>

<div class="game-info-sub-section" *ngIf="shouldShowContractSection">
  <div *ngIf="isDoublingCountRound" class="game-info-value">
    {{ doublingCountRoundLabel }}
  </div>

  <div>
    <div class="game-info-label">{{ declarerLabel }}:</div>
    <div class="game-info-value">
      {{ declarerUsername }}
    </div>
  </div>

  <div>
    <div class="game-info-label">{{ contractLabel }}:</div>
    <div class="game-info-value" *ngIf="isContractDeclared">
      {{ contractName }}
    </div>
  </div>

  <div *ngIf="shouldShowTalonCardsInGameInfo">
    <div class="game-info-label">{{ talonLabel }}:</div>
    <div class="game-info-value">
      <ng-container *ngFor="let card of talonCards; trackBy: cardTrackBy">
        <span class="rank">{{ card.rankSymbol }}</span
        >{{ card.suiteSymbol }}
      </ng-container>
    </div>
  </div>
</div>

<div class="game-info-sub-section" *ngIf="shouldShowDeclaredDefendOptions">
  <div *ngIf="shouldShowUserDefendOption">
    <div class="game-info-label">{{ userUsername }}:</div>
    <div class="game-info-value">
      {{ userDeclaredDefendOption }}
    </div>
  </div>

  <div *ngIf="shouldShowRightOpponentDefendOption">
    <div class="game-info-label">{{ rightOpponentUsername }}:</div>
    <div class="game-info-value">
      {{ rightOpponentDeclaredDefendOption }}
    </div>
  </div>

  <div *ngIf="shouldShowLeftOpponentDefendOption">
    <div class="game-info-label">{{ leftOpponentUsername }}:</div>
    <div class="game-info-value">
      {{ leftOpponentDeclaredDefendOption }}
    </div>
  </div>
</div>

<div *ngIf="shouldShowPreviousTrick" class="game-info-sub-section">
  <div>{{ previousTrickLabel }}</div>

  <div *ngIf="shouldShowUserPreviousTrick">
    <div class="game-info-label">{{ game.user.username }}:</div>
    <div class="game-info-value">
      <span class="rank">{{ userPreviousTrick.card.rankSymbol }}</span
      >{{ userPreviousTrick.card.suiteSymbol }}
    </div>
  </div>

  <div *ngIf="shouldShowRightOpponentPreviousTrick">
    <div class="game-info-label">{{ rightOpponentUsername }}:</div>
    <div class="game-info-value">
      <span class="rank">{{ rightOpponentPreviousTrick.card.rankSymbol }}</span
      >{{ rightOpponentPreviousTrick.card.suiteSymbol }}
    </div>
  </div>

  <div *ngIf="shouldShowLeftOpponentPreviousTrick">
    <div class="game-info-label">{{ leftOpponentUsername }}:</div>
    <div class="game-info-value">
      <span class="rank">{{ leftOpponentPreviousTrick.card.rankSymbol }}</span
      >{{ leftOpponentPreviousTrick.card.suiteSymbol }}
    </div>
  </div>
</div>

<div class="game-info-sub-section">
  <div class="game-info-doubling-count-sub-section">
    <div class="doubling-count-label-value">
      <div class="game-info-label doubling-count">
        {{ doublingCountRoundsLeftLabel }}:
      </div>
      <div class="game-info-value doubling-count">
        {{ doublingCountRoundsLeftToQueue }}
      </div>
    </div>

    <div class="doubling-count-label-value">
      <div class="game-info-label doubling-count">
        {{ doublingCountRoundsQueuedLabel }}:
      </div>
      <div class="game-info-value doubling-count">
        {{ doublingCountRoundsQueued }}
      </div>
    </div>

    <div class="doubling-count-label-value">
      <div class="game-info-label doubling-count">
        {{ game.user.username }}:
      </div>
      <div class="game-info-value doubling-count">
        {{ game.user.doublingCountRoundsPlayed }}
      </div>
    </div>

    <div class="doubling-count-label-value">
      <div class="game-info-label doubling-count">
        {{ rightOpponentUsername }}:
      </div>
      <div class="game-info-value doubling-count">
        {{ rightOpponentDoublingCountRoundsPlayed }}
      </div>
    </div>

    <div class="doubling-count-label-value">
      <div class="game-info-label doubling-count">
        {{ leftOpponentUsername }}:
      </div>
      <div class="game-info-value doubling-count">
        {{ leftOpponentDoublingCountRoundsPlayed }}
      </div>
    </div>
  </div>
</div>

<div class="game-info-sub-section game-score">
  <sans-game-scores
    [user]="game.user"
    [rightOpponent]="game.rightOpponent"
    [leftOpponent]="game.leftOpponent"
    [userPlayerScoreCard]="userPlayerScoreCard"
    [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
    [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
  ></sans-game-scores>
</div>
